import pickBy from 'lodash/pickBy';
import { pick } from 'lodash/fp';

import config from '@config';

import createDataSource from '../createDataSource';
import { getDefaultEmptyList, getDefaultListHandler, makeGetByIds } from '../utils';

import { PAGE_TYPE_ID_TO_SUFFIX } from './constants';

const BASE_PATHNAME = 'pages';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const getById = ({ id, locale }) => {
    if (locale) {
      return dataSource.get(`${BASE_PATHNAME}/${id}/${locale}`).json();
    }
    return dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  };
  const getByIds = makeGetByIds({ dataSource, url: `${BASE_PATHNAME}/getmany` });

  const remove = ({ id, contentId, language }) => {
    if (contentId) {
      return dataSource.delete(`${BASE_PATHNAME}/${contentId}/${language}`);
    }
    return dataSource.delete(`${BASE_PATHNAME}/${id}/${language}`);
  };

  const create = ({ values: json }) =>
    dataSource.post(`${BASE_PATHNAME}/${PAGE_TYPE_ID_TO_SUFFIX[json.typeId]}`, { json }).json();
  const update = ({ id, values }) =>
    dataSource.put(`${BASE_PATHNAME}/${PAGE_TYPE_ID_TO_SUFFIX[values.typeId]}`, { json: { ...values, id } }).json();

  const publish = async ({ id, values, dateTime }) => {
    const page = await (id ? update({ id, values }) : create({ values }));

    if (page.language) {
      return dataSource
        .put(`${BASE_PATHNAME}/${page.id}/${page.language}/publish`, { searchParams: pickBy({ dateTime }) })
        .json();
    }

    return dataSource.put(`${BASE_PATHNAME}/${page.id}/publish`, { searchParams: pickBy({ dateTime }) }).json();
  };
  const unpublish = ({ id, contentId, language }) => {
    if (contentId) {
      return dataSource.put(`${BASE_PATHNAME}/${contentId}/${language}/unpublish`).json();
    }
    return dataSource.put(`${BASE_PATHNAME}/${id}/unpublish`).json();
  };

  const duplicate = ({ contentId }) => dataSource.post(`${BASE_PATHNAME}/${contentId}/duplicate`).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['eventId', 'siteId', 'typeId', 'liveBlog', 'competitionPage', 'dateFilter', 'minisiteId']),
      defaultFilters: { language: 'en' },
    }),

    getPublishedList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick(['eventId', 'siteId', 'typeId', 'liveBlog', 'competitionPage', 'dateFilter']),
      defaultFilters: { language: 'en', isPublished: true },
    }),

    getTypeList: ({ allowedForTypeId }) => {
      if (allowedForTypeId) {
        return dataSource.get(`page-types/${allowedForTypeId}/allowed-types`).json();
      }
      return dataSource.get('page-types').json();
    },

    getById,

    getByIds,

    remove,

    create,

    update,

    publish,

    unpublish,

    duplicate,

    getEmptyList: getDefaultEmptyList,
  };
};
